// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__nZ4nJ","active":"Nav_active__cDyyR"};